export const REASONS_FOR_LEAVING_MODEL = "reasons-for-leaving";

const reasonsForLeavingModel = {
  name: ""
};

export default reasonsForLeavingModel;
